var React = require('react');

function Postcode (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none"},[React.createElement("path",{"d":"M10.656 13.35c.238-.303.46-.591.665-.862 2.203.61 3.679 1.73 3.679 3.012 0 1.933-3.358 3.5-7.5 3.5C3.358 19 0 17.433 0 15.5c0-1.28 1.471-2.399 3.668-3.01.205.272.428.56.666.863C2.327 13.825 1 14.699 1 15.5 1 16.673 3.844 18 7.5 18s6.5-1.327 6.5-2.5c0-.802-1.332-1.677-3.344-2.15z","fill":"#343A40","key":0}),React.createElement("path",{"d":"M7.5 15.716c2.411-2.926 3.93-4.948 4.543-6.042.722-1.29.957-2.305.957-3.527C13 3.311 10.544 1 7.5 1S2 3.311 2 6.147c0 1.237.23 2.249.944 3.527.612 1.096 2.135 3.118 4.555 6.042zM7.5 9a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z","stroke":"#343A40","key":1})]));
}

Postcode.defaultProps = {"width":"15","height":"19","viewBox":"0 0 15 19"};

module.exports = Postcode;

Postcode.default = Postcode;
